export default {
  componentView: {category: 'component', type: 'component', source: 'javascript'},
  eventTracking: {category: 'track', type: 'track', source: 'javascript'},
  liveChat: {category: 'ez-manage', subCategory: 'chat', type: 'track', source: 'javascript'},
  pageView: {category: 'page', type: 'page', source: 'javascript'},
};
